import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {
    deletedRestoreSubjectGroups,
    deleteSubjectGroups,
    setSubjectGroups, setSubjectGroupsRestore
} from "../store/subjectGroupsSlice";
import {ISubjectGroupCreate, ISubjectGroupPayload} from "../types";



const GetSubjectGroups = createAsyncThunk(
    "get/subject/groups",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.get("/subject-groups");

            dispatch(setSubjectGroups(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const CreateSubjectGroups = createAsyncThunk(
    "create/subject/groups",
    async (data: ISubjectGroupCreate, { rejectWithValue}) => {
        try {
            const response = await request.post("/subject-groups", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteSubjectGroups = createAsyncThunk(
    "delete/subject/groups",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.delete(`/subject-groups/${id}`);

            dispatch(deleteSubjectGroups(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditSubjectGroups = createAsyncThunk(
    "edit/subject/groups",
    async (data: ISubjectGroupPayload, { rejectWithValue}) => {
        try {
            const response = await request.put(
                `/subject-groups/${data.id}`,
                data
            );
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeletedSubjectGroups = createAsyncThunk(
    "get/delete/subject/groups",
    async (_, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/subject-groups/deleted-items`);

            dispatch(deletedRestoreSubjectGroups(response.data));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteSubjectGroups = createAsyncThunk(
    "restore/delete/subject/groups",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.post(`/subject-groups/restore/${id}`);

            dispatch(setSubjectGroupsRestore(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetSubjectGroups,
    CreateSubjectGroups,
    DeleteSubjectGroups,
    EditSubjectGroups,
    GetDeletedSubjectGroups,
    RestoreDeleteSubjectGroups
};
